import { atom } from "jotai";

export const isPublicAtom = atom(false);
isPublicAtom.debugLabel = "isPublicAtom";

export const isEmbedAtom = atom(false);
isEmbedAtom.debugLabel = "isEmbedAtom";

export const isViewOnlyDowntimeOverrideAtom = atom(false);
isViewOnlyDowntimeOverrideAtom.debugLabel = "isViewOnlyDowntimeOverrideAtom";

export const isViewOnlyModeAtom = atom(false);

isViewOnlyModeAtom.debugLabel = "isViewOnlyModeAtom";
